import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HTTPCONSTANTS, MerchantService} from '@odin/odin-core';
import moment from 'moment';
import {Observable, of} from 'rxjs';
import type { ISettlement, ITransactionSettled } from '../models';

@Injectable()
export class SettlementsService {
  private readonly baseUrl: string = `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.odinBaseAddress}`;
  private selectedSummary!: ISettlement;

  constructor(private readonly http: HttpClient, private merchantService: MerchantService) {}

  setSelectedSummary(summary: ISettlement): void {
    this.selectedSummary = summary;
  }

  getSelectedSummary(): ISettlement {
    return this.selectedSummary;
  }

  getSettlements(
    merchantRef: string,
    page: number,
    take: number,
  ): Observable<ISettlement[]> {
    const today = moment().format('YYYY-MM-DD');

    const url = this.constructUrlWithQueryString(
      merchantRef,
      today,
      page,
      take,
      'daily',
    );

    return this.http.get<ISettlement[]>(url);
  }

  getSettledTransactions(
    merchantRef: string,
    date: string,
    page: number,
    take: number,
  ): Observable<ITransactionSettled[]> {
    const url = this.constructUrlWithQueryString(
      merchantRef,
      date,
      page,
      take,
      'date',
    );

    return this.http.get<ITransactionSettled[]>(url);
  }

  getTotalSummaryForDay(
    merchantRef: string,
    date: Date,
  ): Observable<ISettlement[]> {
    const dateString = moment(date).format('YYYY-MM-DD');
    const url = this.constructUrlWithQueryString(
      merchantRef,
      dateString,
      0,
      1,
      'daily',
    );
    return this.http.get<ISettlement[]>(url);
  }

  private constructUrlWithQueryString(
    merchantRef: string,
    date: string,
    page: number,
    take: number,
    type: string,
  ): string {
    const url = `${this.constructUrl(merchantRef)}/${type}/${date}`;

    const queryString = `page=${page}&take=${take}`;
    const merchantMid = this.merchantService.getCurrentMid();
    if (merchantMid === null || merchantMid === undefined) return `${url}?${queryString}`;
    return `${url}?monekId=${merchantMid.monekId}&${queryString}`;
  }

  private constructUrl(merchantRef: string): string {
    return `${this.baseUrl}/transactions/v1/settlements/${merchantRef}`;
  }
}
